import React from 'react'
import Carousel from './Carousel';
import HomeUpdates from './HomeUpdates';
import Attendance from './Attendance';



export default function MainHome({data}) {
    
    return (
        <div className="px-2 md:px-8 py-1 overflow-auto" style={{ height: 'calc(100% - 64px)' }}>
            <Carousel />
            <Attendance data={data}/>
            <HomeUpdates />
        </div>
    )
}
